import './StepSection.scss'
import {PropsWithChildren} from 'react'
import {Title} from '../../../../../genericComponents/typographie/UIKitV2/Title'
import {Description} from '../../../../../genericComponents/typographie/Description'

export const StepSection = ({
                                title,
                                description,
                                children,
                                divider = false
                            }: {
    title: string,
    description?: string,
    divider? : boolean
} & PropsWithChildren) => {
    return <div className={`step-section ${divider ? 'divider' : ''}`}>
        <div className="step-section-header">
            <Title title={title}/>
            {description && <Description>{description}</Description>}
        </div>
        <div className="step-section-content">
            {children}
        </div>
    </div>
}